<div class="main main-body-scroll my-2 pt-2">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-2">
                <img class="salesBuzz" src="assets/images/buzz-logo-menu.png" alt="salesBuzz">
            </div>
            <div class="col-auto">
                <button class="primary-btn mx-1"(click)="RequestLicense()">{{"RequestLicense"| translate}}</button>
                <button class="outline" (click)="handleFileUpload()">{{"ImportLicenseFile"| translate}}</button>
                <input #fileInput type="file" (change)="onFileChange($event)" style="display: none;" />
            </div>
        </div>
        <div class="row">
            <div><label>{{"version"|translate}}: &nbsp;</label>
                <small>{{Version}}</small>
            </div>
            <div><label>{{"LicenseTo"|translate}}: &nbsp;</label>
                <small>{{LicenseTo}}</small>
            </div>
            <div><label>{{"LicenseType"|translate}}: &nbsp;</label>
                <small>{{LicenseType}}</small>
            </div>
        </div>
        <hr />
        <div class="content">
            <h4 class="title">{{"overview"|translate}}</h4>
            <p>{{"AboutSalesbuzz"|translate}}</p>
            <h5 class="title">{{"KeyFeatures"|translate}}</h5>
            <ul>
                <li>{{"TripPlanning"|translate}}</li>
                <li>{{"ContactManagement"|translate}}</li>
                <li>{{"OrderProcessing"|translate}}</li>
                <li>{{"Invoicing"|translate}}</li>
                <li>{{"InventoryControl"|translate}}</li>
                <li>{{"Tracing"|translate}}</li>
                <li>{{"Reporting"|translate}}</li>
            </ul>
        </div>
        <hr/>
        <footer>
            <div class="float-end bi-content">
                <span>powered by &nbsp;</span>
                <img src="assets/images/bi-logo.png" alt="">
                <br>
                <span> &copy; {{"CopyrightBItechnologies"|translate}}</span>
            </div>
        </footer>
    </div>
    
</div>